import type {
  IOrderService,
  OrderService,
  VatInfo,
  GetCOVOrdersParams,
  GetCOVOrderDetailParams,
  GetPromotionsParams,
  GetOrderParams,
  IMarketplaceOrderDetail,
} from '@teko/order';

class OrderServiceWrapper implements IOrderService {
  private baseUrl: string;
  private servicePromise: Promise<OrderService> = null;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  private async intializeService(): Promise<OrderService> {
    if (!this.servicePromise) {
      this.servicePromise = import('@teko/order').then(
        (mod) => new mod.OrderService(this.baseUrl),
      );
    }
    return this.servicePromise;
  }

  async getOrder(params: GetOrderParams): Promise<IMarketplaceOrderDetail> {
    const service = await this.intializeService();
    return service.getOrder(params);
  }

  async getOrders(params: GetCOVOrdersParams) {
    const service = await this.intializeService();
    return service.getOrders(params);
  }

  async getOrderDetail(params: GetCOVOrderDetailParams) {
    const service = await this.intializeService();
    return service.getOrderDetail(params);
  }

  async importOrder(orderId: string) {
    const service = await this.intializeService();
    return service.importOrder(orderId);
  }

  async updateVatInfo(orderId: string, vatInfo: VatInfo) {
    const service = await this.intializeService();
    return service.updateVatInfo(orderId, vatInfo);
  }

  async getPromotions(params: GetPromotionsParams) {
    const service = await this.intializeService();
    return service.getPromotions(params);
  }
}

export default OrderServiceWrapper;
